/**
 * description: 
 * this is the coolest modal to use at Tradera.com. the width of the content of this modal 
 * decides how big this modal should be.
 * 
 * Important: the "bp" class needs to exist as a parent before using the Modal component.

 */

import React, { Component } from 'react';
import PropType from 'prop-types';
import './modal.scss';

class SimpleModal extends Component {
    closeOnEscape = e => {
        const { closeModalCallback } = this.props;
        if (e.keyCode === 27) {
            if (!!closeModalCallback) {
                closeModalCallback();
            }
            e.preventDefault();
        }
    };

    componentDidMount() {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this.closeOnEscape);
    }

    componentWillUnmount() {
        document.body.style.overflow = 'visible';
        window.removeEventListener('keydown', this.closeOnEscape);
    }

    render() {
        const {
            children,
            closeModalCallback,
            cssClass,
            modalStyle,
            cssClassBody,
            modalBodyStyle
        } = this.props;

        return (
            <div
                className={`react-modal d-flex justify-content-center z-modal ${cssClass}`}
                style={modalStyle}
                onClick={() => {
                    closeModalCallback();
                }}>
                <div
                    className={`react-modal-body ${cssClassBody}`}
                    style={modalBodyStyle}
                    onClick={e => {
                        e.stopPropagation();
                    }}>
                    {children}
                </div>
            </div>
        );
    }
}

SimpleModal.propTypes = {
    children: PropType.node.isRequired,
    closeModalCallback: PropType.func,
    cssClass: PropType.string,
    modalStyle: PropType.object,
    cssClassBody: PropType.string,
    modalBodyStyle: PropType.object
};

SimpleModal.defaultProps = {
    cssClass: '',
    modalStyle: {},
    cssClassBody: '',
    modalBodyStyle: {}
};

export default SimpleModal;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/simple-modal.jsx